export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14731.df4a9ded.jpg";